export const groupDataByMonth = (data) => {
  const groupedByMonth = data.reduce((acc, item: any) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [day, month, year] = item.date.split('-');
    const monthYear = `${month}-${year}`;

    if (!acc[monthYear]) {
      acc[monthYear] = 0;
    }

    acc[monthYear] += item.number;
    return acc;
  }, {});

  return Object.keys(groupedByMonth).map((key) => ({
    date: key,
    number: groupedByMonth[key],
  }));
};
